import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inContentProcessors } from '../../canvas/injection/ContentInjector';
import { Package, PackageHost } from '../../Container';
import { CsvDataProcessor } from './CsvDataProcessor';
import { importDataFromCsvFile } from './ImportDataFromCsvFilePopup';
import { importData } from './ImportDataPopup';
import { StupidWinExcelCsvFixDataProcessor } from './StupidWinExcelCsvFixDataProcessor';
import { TableFromHtmlDataProcessor } from './TableFromHtmlDataProcessor';

export class TabularImportPackage implements Package {

    public install = (host: PackageHost) => host
        .plug(inCommands(importData, importDataFromCsvFile))
        .plug(inContentProcessors(
            StupidWinExcelCsvFixDataProcessor,
            CsvDataProcessor,
            TableFromHtmlDataProcessor)
        );
}
